<template>
  <div>
    {{ text }} <br><br>
    <a :href="pdfUrl" target="_blank" style="color: #195300;">{{ buttonText }}</a>
  </div>
</template>

<script>
export default {
  props: [
      'pdfUrl',
      'text',
      'buttonText',
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/elements/ToastAlert.vue